// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const rolesFullfilledReducer = makeSetReducer(['roles/fullfilled']);
